import React from 'react'
import firebase from './../Firestore'

import AgregarCarrito from './AgregarCarrito';



class ProductoGenerico extends React.Component {

  _isMounted = false;

  constructor(props) {
  super(props);
  this.state = {
    productosLista: [],

   };
 };



levantaDatos(){
  var db = firebase.firestore();
  db.collection("producto").where("categoriaID", "==", this.props.categoriaId).orderBy("orden", "asc").get().then((snapShots) => {
        this.setState(
          {
            productosLista: snapShots.docs.map(doc => {
              return {
                "nombre": doc.data().nombre,
                "descripcion": doc.data().descripcion,
                "id": doc.id,
                "imagen": doc.data().imagen,
                "orden": doc.data().orden,
                "precio": doc.data().precio,
                "categoriaId": doc.data().categoriaID,
                "cantidad": 0
              }
            })
          }
        );
  });
}

   //UNSAFE_componentWillMount(){

componentDidMount(){
     this._isMounted = true;
     if (this._isMounted) {
       this.levantaDatos()
     }
         //console.log('will mount.', this.state.productosLista);
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

   onChange(event) {

     if(event.target.name === 'subCategoria'){
       this.setState({ productoSeleccionado: event.target.value })
     }else if(event.target.name === 'subCategoria2'){
       this.setState({ idOtraMitad: event.target.value })
     } else if(event.target.name === 'seFracciona'){
         //alert("event checked", event.target.checked)
         this.setState({ esMitad: event.target.checked })
         if(!event.target.checked) this.setState({ idOtraMitad: 0 })
     }

   }

   onClick(event) {

      //console.log(event.target.nodeName)
      event.currentTarget.classList.add("table-active");
      //this.setState({ Productoslista: {cantidad: 1} })

      var nuevaCantidad
      if(event.target.id === "resta"){

        var actualCantidad = Number(event.currentTarget.dataset.cant);
        //console.log("entro quitar", actualCantidad)
        if(actualCantidad > 0){
          //console.log("entro quitar")
          nuevaCantidad = actualCantidad -1;
          if(actualCantidad === 1) event.currentTarget.classList.remove("table-active");

        }

      }else{
        nuevaCantidad = Number(event.currentTarget.dataset.cant) + 1;
      }



      this.updateItem(event.currentTarget.id, {cantidad: nuevaCantidad});

       }

   updateItem(id, itemAttributes) {
     var index = this.state.productosLista.findIndex(x=> x.id === id);
     if (index === -1){
       // handle error
     }
     else{
       this.setState({
         productosLista: [
            ...this.state.productosLista.slice(0,index),
            Object.assign({}, this.state.productosLista[index], itemAttributes),
            ...this.state.productosLista.slice(index+1)
         ]
       });
     }

   }

componentDidUpdate(prevProps, prevState, snapshot){
  this._isMounted = true;
  if (this._isMounted) {
    if(this.props.categoriaId !== prevProps.categoriaId){
      this.levantaDatos()
    }
  }
}

   render() {
    //console.log("Productoslista", this.state.productosLista, this.state.productosLista.length)

    var cantTotalEmpanadas = 0;
    var importeTotalEmpanadas = 0;

    for (var index in this.state.productosLista) {
        cantTotalEmpanadas += this.state.productosLista[index].cantidad;
        importeTotalEmpanadas += this.state.productosLista[index].cantidad * this.state.productosLista[index].precio
    }
    //console.log(cantTotalEmpanadas, importeTotalEmpanadas )

    //const carpetaImg = "../../img/productos/"
    const Items = this.state.productosLista.map((todo, i) =>

      <tr id={todo.id} key={todo.id} data-cant={this.state.productosLista[i].cantidad} onClick={event => this.onClick(event)}>
        <td className="align-top text-center">

          {todo.imagen &&
            <img src={todo.imagen} alt={todo.nombre} className="img-fluid w-50 rounded" ></img>
          }

          <p className="mx-1">

            <span className="float-left"><i id="suma" className="fas fa-plus-circle text-success fa-2x mr-2"></i></span>
            {this.state.productosLista[i].cantidad > 0 &&
              <span className="badge badge-pill badge-primary mr-2">{this.state.productosLista[i].cantidad}</span>
            }
            <strong className="mr-2">{todo.nombre}</strong>
            {this.state.productosLista[i].cantidad > 0 ? (
              <span>$ {todo.precio * this.state.productosLista[i].cantidad}</span>
            ) : (
              <span className="text-muted">$ {todo.precio}</span>
              )}
            <br/>
            <small>{todo.descripcion}</small>




          {this.state.productosLista[i].cantidad > 0 ? (
            <i id="resta" className="fas fa-minus-circle float-right text-danger fa-2x"></i>
          ) : (
            <span></span>
            )}
          </p>

        </td>
      </tr>

    );


    return (

      <table className="table table-sm">
        <thead>
          <tr>
            <td colSpan="4">
            {cantTotalEmpanadas === 0 ? (
              <span>Tocando cada ítem lo sumas al pedido (se puede quitar después).</span>
            ) : (
              <div className="bg-light m-1 p-1 rounded border border-success">
                <p className="text-center mb-0"><small>Items seleccionados: <span className="badge badge-pill badge-primary">{cantTotalEmpanadas}</span> | $ {importeTotalEmpanadas}</small></p>
                <AgregarCarrito uid={this.props.uid} diseno={this.props.diseno} productosLista={this.state.productosLista} adicionalesSeleccionados={this.state.adicionalesSeleccionados}/>
              </div>
              )}
            </td>

          </tr>
        </thead>

        <tbody>
          {Items}
        </tbody>
        </table>

    );
  }
}

export default ProductoGenerico
